var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackPersonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_38)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2001_38",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2001_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0013 8.50065C5.88797 8.50065 4.16797 6.78065 4.16797 4.66732C4.16797 2.55398 5.88797 0.833984 8.0013 0.833984C10.1146 0.833984 11.8346 2.55398 11.8346 4.66732C11.8346 6.78065 10.1146 8.50065 8.0013 8.50065ZM8.0013 1.83398C6.4413 1.83398 5.16797 3.10732 5.16797 4.66732C5.16797 6.22732 6.4413 7.50065 8.0013 7.50065C9.5613 7.50065 10.8346 6.22732 10.8346 4.66732C10.8346 3.10732 9.5613 1.83398 8.0013 1.83398Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7267 15.1667C13.4534 15.1667 13.2267 14.94 13.2267 14.6667C13.2267 12.3667 10.8801 10.5 8.00013 10.5C5.1201 10.5 2.77344 12.3667 2.77344 14.6667C2.77344 14.94 2.54677 15.1667 2.27344 15.1667C2.0001 15.1667 1.77344 14.94 1.77344 14.6667C1.77344 11.82 4.56676 9.5 8.00013 9.5C11.4335 9.5 14.2267 11.82 14.2267 14.6667C14.2267 14.94 14.0001 15.1667 13.7267 15.1667Z",
    fill: "#5A5A5A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackPersonIcon);
export default __webpack_public_path__ + "static/media/feedback-person-icon.7d20045534e23ff2a205298b9c528fb3.svg";
export { ForwardRef as ReactComponent };